import { PaymentType } from '@repo/shared/components'
import {
  AspectRatio,
  Badge,
  Col,
  Icon,
  Row,
  Typography,
} from '@repo/ui/components'
import { UserPricePerformance, UserProject } from '@repo/services'
import { twMerge } from 'tailwind-merge'
import Image from 'next/image'
import { globalConfig } from '@repo/shared/utils'
import { useMemo } from 'react'
import { Link } from '@repo/shared/i18n/navigation'

const ImageComp = ({ src }: { src?: string }) => {
  const url = src
    ? `${globalConfig.baseImageUrl}${src}`
    : '/images/placeholder.webp'

  return (
    <div className='w-lg'>
      <AspectRatio className=' aspect-1/1'>
        <Image
          src={url}
          alt='Photo of property'
          fill
          sizes='(max-width: 768px) 100vw, 32px'
          className='h-full w-full  rounded-2xs object-cover'
          loading='lazy'
        />
      </AspectRatio>
    </div>
  )
}

export const DashboardMarketSummaryCardItem = (
  props: UserPricePerformance & { projects: UserProject[] },
) => {
  const { symbol, lastPrice, deltaPercent } = props
  const isPositive = (deltaPercent ?? 0) > 0
  const isZero = deltaPercent === 0
  const project = useMemo(
    () => props.projects.find((p) => p.token === symbol),
    [props.projects, symbol],
  )
  if (!project) return null
  return (
    <Col as={Link} href={`/rwa/${symbol}`} className='gap-xs py-sm px-md'>
      <Row className='justify-between'>
        <Typography
          variant='bdi'
          size='sm'
          className='text-neutral-surface-100  font-[AzarMehr] '
        >
          {symbol}
        </Typography>
        <ImageComp src={project?.logoURL} />
      </Row>
      <Typography size='xs' className='text-neutral-surface-60'>
        {project?.displayName}
      </Typography>

      <Row className='justify-between'>
        <Badge
          color='custom'
          size='sm'
          className={twMerge(
            'flex gap-xs',
            isZero
              ? 'text-neutral-surface-100'
              : isPositive
                ? 'text-positive-surface-100'
                : 'text-negative-surface-100',
          )}
        >
          {isZero ? (
            '0%'
          ) : (
            <bdi>
              {isPositive && '+'}
              {Math.floor((deltaPercent ?? 0) * 100) / 100}%
            </bdi>
          )}
          {!isZero && (
            <Icon
              name={isPositive ? 'TriangleUp' : 'TriangleDown'}
              size='xs'
              className={twMerge('-mr-xs', isPositive && '-mt-[2px]')}
              color={`fill-${isPositive ? 'positive-surface-100' : 'negative-surface-100'}`}
            />
          )}
        </Badge>

        <Row className='gap-2xs w-fit'>
          <PaymentType
            value={lastPrice}
            color='text-neutral-surface-80'
            numberColor='text-neutral-surface-100'
            numberSize='md'
            size='xs'
            isBold={false}
          />
        </Row>
      </Row>
    </Col>
  )
}
